export const POSTER_MOBILE_TIMELINE_HEIGHT_RATIO = 0.5;
export interface PosterEditorMobileTimelineProps {}
